import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DataFormatService {
    public static value: string = 'MM/DD/YYYY hh:mm:ss A';
}
